import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Network, Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleOAuthCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent StrictMode double-call
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Authentication failed');
          navigate('/login');
          return;
        }

        // Exchange session_id for session_token
        await handleOAuthCallback(sessionId);
        
        // Clear the hash and navigate to feed
        window.history.replaceState(null, '', '/feed');
        toast.success('Welcome to net-o-pad!');
        navigate('/feed', { replace: true });
      } catch (error) {
        console.error('OAuth callback error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate('/login');
      }
    };

    processCallback();
  }, [handleOAuthCallback, navigate]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center">
          <Network className="w-7 h-7 text-white" />
        </div>
        <span className="text-3xl font-bold text-foreground font-serif">net-o-pad</span>
      </div>
      <Loader2 className="w-8 h-8 text-primary animate-spin" />
      <p className="mt-4 text-muted-foreground">Completing sign in...</p>
    </div>
  );
};

export default AuthCallback;
